<template>
  <v-select
    id="urs-select"
    v-model ="filter.id_unidade_regional"
    item-text ="nomeRegiao"
    item-name ="id_unidade_regional"
    item-value ="id_unidade_regional"
    :items="urs"
    label ="Unidade Regional"
    placeholder ="Unidade Regional"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhuma UR
    </template>
  </v-select>
</template>

<script>
import { urAPI } from '../API/urAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppUrCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadUrs()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadUrs () {
      urAPI.getByUf(this.$store.state.uf)
        .then(resp => {
          this.urs = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      urs: []
    }
  }
}
</script>
